interface IPagination {
  page: number;
  pages?: number;
  count?: number;
  limit: number;
  next?: string;
  previous?: string;
}

const defaultPagination = (
  page: number = 1,
  limit: number = 10,
): IPagination => ({
  page,
  limit,
});

const defaultGridPagination = (
  page: number = 1,
  limit: number = 12,
): IPagination => ({
  page,
  limit,
});

export type { IPagination };
export { defaultPagination };
export { defaultGridPagination };
